"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = scrollTo;

var _hasOwn = _interopRequireDefault(require("../_internal/hasOwn"));

var _isObject = _interopRequireDefault(require("../lang/isObject"));

var _isFunction = _interopRequireDefault(require("../lang/isFunction"));

var _linear = _interopRequireDefault(require("../easing/linear"));

var _ease = _interopRequireDefault(require("../easing/ease"));

var _easeIn = _interopRequireDefault(require("../easing/easeIn"));

var _easeInOut = _interopRequireDefault(require("../easing/easeInOut"));

var _easeOut = _interopRequireDefault(require("../easing/easeOut"));

var _cubicBezier = _interopRequireDefault(require("../easing/cubicBezier"));

var _raf = _interopRequireDefault(require("../raf"));

var _isWindow = _interopRequireDefault(require("./isWindow"));

var _isElement = _interopRequireDefault(require("./isElement"));

var _scrollX = _interopRequireDefault(require("./scrollX"));

var _scrollY = _interopRequireDefault(require("./scrollY"));

var easings = {
  linear: _linear["default"],
  ease: _ease["default"],
  'ease-in': _easeIn["default"],
  'ease-in-out': _easeInOut["default"],
  'ease-out': _easeOut["default"]
};
var reEasingKeyword = /^(linear|ease|ease-in|ease-in-out|ease-out)$/;
var reCubicBezier = /^cubic-bezier\(\s*(\d*\.?\d+)\s*,\s*(\d*\.?\d+)\s*,\s*(\d*\.?\d+)\s*,\s*(\d*\.?\d+)\s*\)$/;

function scrollTo(elOrWindow, x, y) {
  if (x === void 0) {
    x = 0;
  }

  if (y === void 0) {
    y = 0;
  }

  var el = window;
  var options = {};

  if ((0, _isElement["default"])(elOrWindow) || (0, _isWindow["default"])(elOrWindow)) {
    el = elOrWindow;

    if ((0, _isObject["default"])(x)) {
      options = x;
    } else {
      options.x = x;
      options.y = y;
    }
  } else {
    if ((0, _isObject["default"])(elOrWindow)) {
      options = elOrWindow;
    } else {
      options.x = elOrWindow || 0;
      options.y = x;
    }
  }

  if (!(0, _hasOwn["default"])(options, 'x')) options.x = options.left || 0;
  if (!(0, _hasOwn["default"])(options, 'y')) options.y = options.top || 0;

  var innerScrollTo = function innerScrollTo(opts) {
    var left = opts.x,
        top = opts.y,
        behavior = opts.behavior;

    if ((0, _isFunction["default"])(el.scrollTo)) {
      if (behavior) {
        el.scrollTo({
          left: left,
          top: top,
          behavior: behavior
        });
      } else {
        el.scrollTo(left, top);
      }
    } else {
      /* istanbul ignore else */
      if (left !== undefined) {
        el.scrollLeft = left;
      }
      /* istanbul ignore else */


      if (top !== undefined) {
        el.scrollTop = top;
      }
    }
  };

  if (options.easing) {
    var easingFn;

    if (reEasingKeyword.test(options.easing)) {
      easingFn = easings[options.easing];
    } else if (reCubicBezier.test(options.easing)) {
      var matched = options.easing.match(reCubicBezier);
      var x1 = 0;
      var y1 = 0;
      var x2 = 0;
      var y2 = 0;
      /* istanbul ignore else */

      if (matched) {
        x1 = Number(matched[1]);
        y1 = Number(matched[2]);
        x2 = Number(matched[3]);
        y2 = Number(matched[4]);
      }

      easingFn = (0, _cubicBezier["default"])(x1, y1, x2, y2);
    } else {
      innerScrollTo(options);
      return;
    }

    var minDuration = 150;
    var maxDuration = 500;
    var startX = (0, _scrollX["default"])(el);
    var startY = (0, _scrollY["default"])(el); // @ts-ignore

    var diffX = options.x - startX; // @ts-ignore

    var diffY = options.y - startY;
    var diff = Math.max(Math.abs(diffX), Math.abs(diffY));
    var duration = Math.min(minDuration + 100 * (diff / 1000), maxDuration);
    var tickTime = 1000 / 16;
    var tickTotal = Math.ceil(duration / tickTime);
    var nextX = startX;
    var nextY = startY;
    var start;
    var tickCount = 0;

    var runScroll = function runScroll(time) {
      if (!start) start = time;

      if (tickCount <= tickTotal) {
        nextX = startX + diffX * Math.max(easingFn(tickCount / tickTotal), 1);
        nextY = startY + diffY * Math.max(easingFn(tickCount / tickTotal), 1);
        innerScrollTo({
          x: nextX,
          y: nextY
        });
        tickCount++;
        (0, _raf["default"])(runScroll);
      }
    };

    (0, _raf["default"])(runScroll);
  } else {
    innerScrollTo(options);
  }
}

module.exports = exports.default;